import { connect } from 'react-redux';
import HillshadeToggle from './HillshadeToggle.jsx';
import { toggleHillshade } from '../store/actions';

const mapStateToProps = state => ({
  hillshadeOn: state.hillshadeOn,
});

const mapDispatchToProps = {
  toggleHillshade,
};

export default connect(mapStateToProps, mapDispatchToProps)(HillshadeToggle);



// WEBPACK FOOTER //
// ./src/components/HillshadeToggle.js